import loadable from '@loadable/component';

// 懒加载组件
const CstStatementConfirmationManagement = loadable(() => import('./cstStatementConfirmationManagement/CstStatementConfirmationManagement'));
const CstStatementConfirmationModify = loadable(() => import('./cstStatementConfirmationManagement/cstStatementConfirmationModify/CstStatementConfirmationModify'));
const PaymentApplicationManagement = loadable(() => import('./paymentApplicationManagement/PaymentApplicationManagement'));
const PaymentApplicationInvoiceModify = loadable(() => import('./paymentApplicationManagement/paymentApplicationInvoiceModify/PaymentApplicationInvoiceModify'));
const HosItemPriceQuery = loadable(() => import('./hosItemPriceQuery/HosItemPriceQuery'));

export const subRoutes = [
  {
    path: '/CstStatementConfirmationManagement',
    component: CstStatementConfirmationManagement
  },
  {
    path: '/CstStatementConfirmationModify',
    component: CstStatementConfirmationModify
  },
  {
    path: '/PaymentApplicationManagement',
    component: PaymentApplicationManagement
  },
  {
    path: '/PaymentApplicationInvoiceModify',
    component: PaymentApplicationInvoiceModify
  },
  {
    path: '/HosItemPriceQuery',
    component: HosItemPriceQuery
  }
];
